import type { UserRole } from '@/stores/authStore';

const KNOWN_TYPES = new Set([
  'CLAIM_SUBMITTED',
  'CLAIM_ADMIN_APPROVED',
  'CLAIM_FINANCE_APPROVED',
  'CLAIM_HR_APPROVED',
  'CLAIM_APPROVED',
  'CLAIM_REJECTED',
  'CLAIM_RETURNED',
]);

/**
 * Review-request notifications: (role, type) -> the queue where that role acts on the claim.
 * The queue pages open claims in an in-page panel, deep-linked with `?claim=<id>`.
 */
const REVIEW_QUEUE: Partial<Record<UserRole, Record<string, string>>> = {
  ADMIN: { CLAIM_SUBMITTED: '/admin/claims-queue', CLAIM_RETURNED: '/admin/claims-queue' },
  IT_ADMIN: { CLAIM_SUBMITTED: '/admin/claims-queue', CLAIM_RETURNED: '/admin/claims-queue' },
  FINANCE: { CLAIM_ADMIN_APPROVED: '/finance/claims-queue' },
  FINANCE_LEAD: { CLAIM_ADMIN_APPROVED: '/finance/claims-queue' },
  HR: { CLAIM_FINANCE_APPROVED: '/hr/claims-queue' },
};

/**
 * Where clicking a notification should take the user, or null when it should only be marked read.
 * STAFF only receive notifications about their own claims -> claim detail.
 * Reviewers receive review requests (-> their queue) and may read any claim (-> claim detail).
 */
export function getNotificationDestination(
  notif: { type: string; referenceId: string | null },
  role: UserRole | undefined
): string | null {
  if (!notif.referenceId || !role || !KNOWN_TYPES.has(notif.type)) return null;
  const queue = REVIEW_QUEUE[role]?.[notif.type];
  if (queue) return `${queue}?claim=${encodeURIComponent(notif.referenceId)}`;
  return `/claims/${notif.referenceId}`;
}
